<template>
  <b-overlay :show="loading">
    <b-form id="form-entity" data-vv-scope="form-entity">
      <div class="row">
        <div class="col-12">
          <b-form-group
            label="Nombre"
            label-for="#"
          >
            <b-form-input
              placeholder="ingresa nombre"
              v-model="selectedEntity.name"
              v-validate="'required|min:6'"
              data-cy="name"
              data-vv-as="Nombre"
              id="name"
              name="name"
              class="w-80"
              :state="errors.has('form-entity.name') ? false : null"
            />
            <b-form-invalid-feedback>
              {{ errors.first('form-entity.name') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group
            label="Dirección"
            label-for="#"
          >
            <b-form-input
              placeholder="ingresa dirección"
              v-model="selectedEntity.address"
              v-validate="'required|min:6'"
              data-cy="address"
              data-vv-as="Dirección"
              id="address"
              name="address"
              :state="errors.has('form-entity.address') ? false : null"
            />
            <b-form-invalid-feedback>
              {{ errors.first('form-entity.address') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <b-form-group label="Responsable">
            <SelectValidate
              v-model="selectedEntity.onCharge"
              :options="entityUsers"
              name="onCharge"
              :danger="errors.has('form-entity.onCharge')"
              :danger-text="errors.first('form-entity.onCharge')"
              :state="errors.has('form-entity.onCharge') ? false : null"
              data-vv-as="responsable"
              v-if="entityUsers"
            />
            <span
              v-if="!entityUsers"
            >
              Entidad no cuenta con usuarios
            </span>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group
            label="Correo Electrónico"
            label-for="#"
          >
            <b-form-input
              placeholder="ingresa correo electrónico"
              v-model="selectedEntity.email"
              v-validate="'required|email'"
              data-cy="email"
              data-vv-as="Correo"
              id="email"
              name="email"
              :state="errors.has('form-entity.email') ? false : null"
            />
            <b-form-invalid-feedback>
              {{ errors.first('form-entity.email') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group
            label="Centro de Costos"
            label-for="#"
          >
            <SelectValidate
              v-model="selectedEntity.costsCenter"
              :options="costsCenter"
              name="costsCenter"
              :danger="errors.has('form-entity.costsCenter')"
              :danger-text="errors.first('form-entity.costsCenter')"
              :state="errors.has('form-entity.costsCenter') ? false : null"
              v-validate="'required'"
              data-vv-as="responsable"
              v-if="costsCenter"
            />
            <span v-if="!costsCenter">
              No se encontraron centro de costos creados
            </span>
          </b-form-group>
        </div>
      </div>
    </b-form>
    <vs-divider></vs-divider>
    <div class="text-right">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        v-on:click="attemptSaveEntity"
        data-cy="save-entity"
      >
        Guardar
      </b-button>
    </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { getCentroCostos } from '@/febos/servicios/api/gestionPresupuesto.api';
import SelectValidate from '@/febos/chile/_vue/componentes/SelectValidate';

export default {
  components: {
    SelectValidate
  },
  data() {
    return {
      selectedEntity: {},
      entityUsers: [],
      costsCenter: [],
      loading: false
    };
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('Materials', [
      'optionUsers'
    ]),
    isFolder() {
      return (this.entity.isFolder);
    }
  },
  methods: {
    ...mapActions('Materials', [
      'editEntity'
    ]),
    async getCostsCenter() {
      const response = await getCentroCostos({
        codigo: '',
        dominioPortal: 'portal.febos.cl',
        itemsPorPagina: '2000',
        nombre: '',
        pagina: '1'
      });
      this.costsCenter = response.data.centrosCostos
        .map((center) => ({
          id: `${center.centroCostoId}`,
          label: `${center.codigo} - ${center.nombre}`,
          value: `${center.codigo} - ${center.nombre}`,
          code: center.codigo,
          name: center.nombre
        }));
    },
    optionSelected(array, selected) {
      return array.find((option) => option.value === selected);
    },
    async attemptSaveEntity() {
      const result = await this.$validator.validateAll('form-entity');
      if (!result) {
        return;
      }
      const onCharge = this.optionSelected(this.entityUsers, this.selectedEntity.onCharge);
      const costCenter = this.optionSelected(this.costsCenter, this.selectedEntity.costsCenter);
      const extraData = {
        ...this.entity,
        isFolder: this.isFolder,
        direccion: this.selectedEntity.address,
        ...(onCharge && onCharge.id && {
          responsableId: onCharge.id,
          responsableNombre: onCharge.label
        }),
        email: this.selectedEntity.email,
        centroCostosId: costCenter.id,
        centroCostosCodigo: costCenter.code,
        centroCostosNombre: costCenter.name
      };
      const body = {
        descripcion: this.selectedEntity.name,
        opcionId: this.entity.optionId,
        padre: this.entity.padre,
        grupoId: this.entity.groupId,
        parametroId: this.entity.parameterId,
        nivel: this.entity.levelNode,
        extra: JSON.stringify(extraData)
      };
      await this.editEntity(body);
      this.$emit('edited');
    }
  },
  async mounted() {
    await this.getCostsCenter();
    this.selectedEntity = {
      ...this.entity,
      address: this.entity.extra.direccion,
      email: this.entity.extra.email,
      ...(this.entity.extra.centroCostosCodigo && {
        costsCenter: `${this.entity.extra.centroCostosCodigo} - ${this.entity.extra.centroCostosNombre}`,
      }),
      onCharge: this.entity.extra.responsableNombre,
    };
    this.entityUsers = this.optionUsers
      .map((user) => ({
        id: user.id,
        label: user.nombre,
        value: user.nombre
      }));
  }
};
</script>
